import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getDistributorList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogDistributor_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getCodeList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogCode_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getProductConfirmList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogProductConfirm_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getProductConfirmErrorList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogProductConfirmError_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getProductConfirmFeedList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogProductConfirmFeed_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getProductConfirmFeedData = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogProductConfirmFeed_DATA', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

//////////////////
///// PUT  ///////
//////////////////
export const updateLogCode = (params) => {
  return (dispatch) => {
    return HttpApi.post('eLogCode_UPDATE', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

